import { render, staticRenderFns } from "./PaymentsTable.vue?vue&type=template&id=4ecb6cd0"
import script from "./PaymentsTable.vue?vue&type=script&lang=js"
export * from "./PaymentsTable.vue?vue&type=script&lang=js"
import style0 from "./PaymentsTable.vue?vue&type=style&index=0&id=4ecb6cd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports